export const defaultStyles = {
  color: "var(--theme-website-color-text-primary)",
  fontWeight: "500",
  fontSize: "1",
  lineHeight: "1.5",
  textTransform: "none",
  fontStyle: "italic",
  textDecoration: "none",
  textAlign: "left",
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
  padding: {
    paddingTop: "4",
    paddingBottom: "4",
    paddingLeft: "8",
    paddingRight: "0",
  },
} as const;
